import React from 'react'
import BlueHeading from '../other/common/BlueHeading'
import Heading from '../common/ui/Heading'

const CelebrateExcellence = () => {
  return (
    <>
      <div className="flex items-center justify-center flex-col pt-[140px] px-4 max-xl:pt-[120px] max-lg:pt-26 max-md:pt-20 max-sm:pt-10">
        <BlueHeading text="Celebrate Excellence" />
        <Heading
          children="Our Achievements Are Testaments to Our Mission"
          className="max-w-[809px] mx-auto text-center"
        />
        <p className="text-[#5E5C5C] text-[26px] max-md:text-base font-normal leading-[150%] pt-4 max-w-[1121px] text-center">
          Makeway India takes immense pride in the recognition received by our
          guiding light, Shri Deepak Ji. Honored on national and international
          platforms, these awards celebrate his exemplary service, commitment to
          societal change, and inspiration to the youth.
        </p>
      </div>
    </>
  );
}

export default CelebrateExcellence